export default function(state = [], action){
    switch(action.type){
        case "SET_TAGS_LIST":
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/tags.js